import { render, staticRenderFns } from "./PurchasePanel.vue?vue&type=template&id=0176e5e1&scoped=true&lang=pug&"
import script from "./PurchasePanel.vue?vue&type=script&lang=js&"
export * from "./PurchasePanel.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePanel.vue?vue&type=style&index=0&id=0176e5e1&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0176e5e1",
  null
  
)

export default component.exports